/** @jsxImportSource @emotion/react */
import createReactClass from "create-react-class";
import ReactPropTypes from "prop-types";
import PureRenderMixin from "react-addons-pure-render-mixin";

import {Column, Layout, Row} from "js/common/views/foundation-column-layout";
import {TextButton} from "js/common/views/inputs/buttons";
import DropdownToggle from "js/common/views/react-dropdown-toggle";
import DatePicker from "js/common/views/inputs/timeframe-picker/react-datepicker";
import ErrorMsg from "js/common/views/error";
import * as TimeframeRepo from "js/common/repo/backbone/timeframe-repo";
import React from "react";
import {CustomThemeContext} from "js/common/themes/CustomThemeProvider";

// overflow:hidden is skipped because velocity's slideDown sets it on the dropdown's own wrapper
// while animating.
const getScrollParent = el => {
  for (let node = el.parentElement; node; node = node.parentElement) {
    const {overflowY} = window.getComputedStyle(node);
    if (overflowY === "auto" || overflowY === "scroll") {
      return node;
    }
  }
  return null;
};

const TimeframePicker = createReactClass({
  displayName: "TimeframePicker",

  mixins: [PureRenderMixin],

  propTypes: {
    onChange: ReactPropTypes.func.isRequired,
    timeframe: ReactPropTypes.object.isRequired,
    isDisabled: ReactPropTypes.bool,
    timeframes: ReactPropTypes.array,
    onClose: ReactPropTypes.func,
    onOpenChange: ReactPropTypes.func,
    label: ReactPropTypes.string,
    labelTooltip: ReactPropTypes.string,
    allowCustomTimeframes: ReactPropTypes.bool
  },

  getDefaultProps() {
    return {
      isDisabled: false,
      allowCustomTimeframes: true,
      onClose: () => {},
      onOpenChange: () => {}
    };
  },

  getInitialState() {
    const {timeframe} = this.props;
    return {
      isOpen: false,
      customStartDate: timeframe.get("start"),
      customEndDate: timeframe.get("end"),
      customDateRangeError: null,
      listMaxHeight: null
    };
  },

  componentWillUnmount() {
    this.teardownMeasurement();
  },

  UNSAFE_componentWillReceiveProps(nextProps) {
    const currentTimeframe = this.props.timeframe;
    const nextTimeframe = nextProps.timeframe;
    if (nextTimeframe.getStart() !== currentTimeframe.getStart()
        || nextTimeframe.getEnd() !== currentTimeframe.getEnd()) {
      this.setState({
        customStartDate: nextTimeframe.get("start"),
        customEndDate: nextTimeframe.get("end")
      });
    }
  },

  render() {
    return (
        <DropdownToggle
            label={this.props.label}
            labelTooltip={this.props.labelTooltip}
            primaryText={this.props.timeframe.get("name")}
            secondaryText={this.getTimeframeDateRangeLabel()}
            isDisabled={this.props.isDisabled}
            isOpen={this.state.isOpen}
            onToggleButtonClick={this.toggleDropdown}
            onRequestClose={this.closeDropdown}
            customStyle={this.props.customStyle}
            testId={"timeframe-picker"}>
          {this.renderTimeframes()}
        </DropdownToggle>);
  },

  getTimeframeDateRangeLabel() {
    const {timeframe} = this.props;
    if (timeframe.get("id").toUpperCase() === "CUSTOM") {
      return;
    }

    const startDate = timeframe.get("start").format("ll").replace(",", "");
    const endDate = timeframe.get("end").format("ll").replace(",", "");
    return `(${startDate} to ${endDate})`;
  },

  toggleDropdown() {
    const isOpen = !this.state.isOpen;
    this.setState({isOpen});
    this.props.onOpenChange(isOpen);
  },

  closeDropdown() {
    const {customStartDate, customEndDate} = this.state;
    const {timeframe, onClose} = this.props;
    this.setState({
      isOpen: false,
      customStartDate: customStartDate.isValid() ? customStartDate : timeframe.get("start"),
      customEndDate: customEndDate.isValid() ? customEndDate : timeframe.get("end")
    });
    this.props.onOpenChange(false);
    onClose();
  },

  // Cap the dropdown so it fills down to a small margin above the viewport
  // bottom — the preset list scrolls inside while the custom-date section
  // stays pinned at the bottom (see the flex layout in renderTimeframes).
  measureMaxHeight() {
    const el = this.containerRef;
    if (!el) {
      return;
    }
    const viewportHeight = typeof window !== "undefined" ? window.innerHeight : 800;
    const top = el.getBoundingClientRect().top;
    const bottomMargin = 16;
    const maxHeight = Math.max(160, Math.round(viewportHeight - top - bottomMargin));
    if (maxHeight !== this.state.listMaxHeight) {
      this.setState({listMaxHeight: maxHeight});
    }
  },

  // The dropdown is absolutely positioned, so a scrolling ancestor such as the edit drawer's content
  // clips it before the viewport does. Scroll that ancestor so the whole dropdown fits instead.
  scrollIntoRoom(el) {
    const scrollParent = getScrollParent(el);
    const clip = scrollParent && scrollParent.getBoundingClientRect();
    if (!clip || clip.bottom >= window.innerHeight) {
      return;
    }
    const list = el.firstChild;
    const fullHeight = el.offsetHeight - list.clientHeight + list.scrollHeight;
    const {top} = el.getBoundingClientRect();
    const shortfall = top + fullHeight + 16 - clip.bottom;
    if (shortfall > 0) {
      scrollParent.scrollTop += Math.min(shortfall, top - clip.top);
    }
  },

  recomputeMaxHeight() {
    cancelAnimationFrame(this.recomputeFrame);
    this.recomputeFrame = requestAnimationFrame(() => this.measureMaxHeight());
  },

  setContainerRef(node) {
    this.containerRef = node;
    if (node) {
      if (!this.onWindowResize) {
        this.onWindowResize = () => this.recomputeMaxHeight();
        window.addEventListener("resize", this.onWindowResize);
      }
      // Measure synchronously on open so the correct height is committed before
      // the browser paints, avoiding a visible resize of the list.
      this.scrollIntoRoom(node);
      this.measureMaxHeight();
    } else {
      this.teardownMeasurement();
    }
  },

  teardownMeasurement() {
    if (this.onWindowResize) {
      window.removeEventListener("resize", this.onWindowResize);
      this.onWindowResize = null;
    }
    cancelAnimationFrame(this.recomputeFrame);
    this.containerRef = null;
  },

  renderTimeframes() {
    const timeframes = this.props.timeframes || getDefaultTimeframes();
    const allowCustomTimeframes = this.props.allowCustomTimeframes;
    const {customStartDate, customEndDate} = this.state;
    return (
        <div>
          {/* The plain wrapper above is the element velocity's slideDown animates;
              the flex column below caps its height to the viewport so the preset
              list scrolls while the custom-date section stays pinned at the bottom. */}
          <div ref={this.setContainerRef} style={timeframeContainerStyle(this.state.listMaxHeight)}>
          <div style={scrollableListStyle}>
          <Layout allSmall={12} rowStyle={{marginTop: "0", padding: "0 1rem"}}>
            {timeframes.map(timeframe => {
              const isDeleted = timeframe.get("isDeleted");
              const isHidden = !timeframe.get("visible");
              const warningLabelStyle = {
                color: "#000",
                borderRadius: 3,
                padding: "0 5px",
                marginLeft: 8
              };
              return <PresetTimeframe
                  key={timeframe.get("id")}
                  id={timeframe.get("id")}
                  theme={this.props.theme}
                  label={<span>
                              <span style={{color: "inherit"}}>{timeframe.get("name")}</span>
                    {isDeleted && <strong style={{...warningLabelStyle, backgroundColor: "#f00"}}>
                      DELETED
                    </strong>}
                    {isHidden && <strong style={{...warningLabelStyle, backgroundColor: "#ff8d00"}}>
                      HIDDEN
                    </strong>}
                            </span>}
                  onClick={() => this.handlePresetTimeframeClick(timeframe)} />;
            })}
          </Layout>
          </div>
          {allowCustomTimeframes && <div style={{flex: "none"}}>
            <Row style={{padding: "0 1rem"}}>
              <Column small={12}>
                <hr
                    style={{
                      margin: "0.5rem 0",
                      border: `1px solid #eee`,
                      borderColor: `${this.props.theme.palette.background.paper}`
                    }} />
                <div className="small-12 columns" style={customDateHeadingStyle(this.props.theme)}>
                  Choose a custom date range
                </div>
              </Column>
            </Row>
            <Layout allSmall={12} allLarge={6} rowStyle={{margin: "0 0.5rem"}} columnStyle={{padding: "0 0.5rem"}}>
              <CustomDatePicker
                  label="Start Date"
                  value={customStartDate}
                  onChange={this.handleStartDateChange}
                  calendarPosition="left" />
              <CustomDatePicker
                  label="End Date"
                  minDate={customStartDate}
                  value={customEndDate}
                  onChange={this.handleEndDateChange}
                  calendarPosition="right" />
            </Layout>
            {customEndDate.isBefore(customStartDate) &&
                <ErrorMsg text="End Date cannot be before Start Date" style={{margin: "0.5rem 1rem"}} />}
            <div
                style={{
                  marginTop: "1rem",
                  marginBottom: "1rem",
                  padding: "0 1rem",
                  textAlign: this.props.theme.themeId === "light" ? "right" : "center"
                }}
            >
              <TextButton
                  type="primary"
                  suffixIcon="clock-o"
                  label="Update"
                  disabled={
                      customEndDate.isBefore(customStartDate)
                      || !customStartDate.isValid()
                      || !customEndDate.isValid()
                  }
                  onClick={this.handleCustomTimeframeSelection}
                  testId={"timeframe-picker-update"} />
            </div>
          </div>}
          </div>
        </div>);
  },

  handlePresetTimeframeClick(timeframe) {
    this.props.onChange(timeframe);
    this.closeDropdown();
  },

  handleStartDateChange(date) {
    this.setState({
      customStartDate: date
    });
  },

  handleEndDateChange(date) {
    this.setState({
      customEndDate: date
    });
  },

  handleCustomTimeframeSelection() {
    const {customStartDate, customEndDate} = this.state;
    const timeframe = TimeframeRepo.parseCustom({
      start: customStartDate,
      end: customEndDate
    });
    this.props.onChange(timeframe);
    this.closeDropdown();
  }

});

const CustomDatePicker = React.memo(({
  label,
  minDate,
  value,
  style,
  onChange,
  calendarPosition
}) => {
  const {palette, themeId} = React.useContext(CustomThemeContext).theme;
  const wrapperRef = React.useRef(null);
  const [openDirection, setOpenDirection] = React.useState("bottom");
  // The custom-date section is pinned at the bottom of a dropdown that fills to
  // the viewport bottom, so the calendar would be cut off opening downward.
  // Open it upward whenever there isn't room below for the ~300px calendar.
  React.useLayoutEffect(() => {
    const el = wrapperRef.current;
    // Skip while the element isn't laid out: velocity's slideDown sets
    // display:none on the dropdown mid-animation, which would measure the
    // position as 0 and wrongly choose "bottom". offsetParent is null then.
    if (!el || !el.offsetParent) {
      return;
    }
    const spaceBelow = window.innerHeight - el.getBoundingClientRect().bottom;
    const direction = spaceBelow < 320 ? "top" : "bottom";
    setOpenDirection(prev => prev !== direction ? direction : prev);
  }, []);
  return (
      <div ref={wrapperRef} style={style} className={`picker-${themeId}`}>
        <label
            style={{
              cursor: "default",
              marginTop: "13px",
              marginBottom: "5px",
              color: palette.text.main,
              textTransform: themeId === "light" ? "uppercase" : "none",
              fontSize: themeId === "light" ? 13 : 12
            }}>
          {label}
        </label>
        <DatePicker onDateChange={onChange} minDate={minDate} value={value} calendarPosition={calendarPosition} position={openDirection} />
      </div>
  );
});

const PresetTimeframe = React.memo(({
  id,
  label,
  onClick,
  theme
}) => <div
    data-test-id={"preset-timeframe-" + id}
    css={presetTimeframeCss(theme)}
    onClick={onClick}>{label}</div>);

const getDefaultTimeframes = () => TimeframeRepo
    .getAll()
    .filter(t => t.get("visible") && !t.get("isDeleted"));

const timeframeContainerStyle = (maxHeight) => ({
  display: "flex",
  flexDirection: "column",
  maxHeight: maxHeight != null ? `${maxHeight}px` : "70vh"
  // No overflow:hidden here — the scroll region below clips/scrolls itself, and
  // clipping here would cut off the custom-date calendar popup (which needs to
  // overflow the dropdown). The maxHeight cap still holds via flex + the scroll
  // region's own overflow.
});

const scrollableListStyle = {
  flex: "1 1 auto",
  minHeight: 0,
  overflowY: "auto",
  // Foundation's Row uses negative margins; without this the vertical scroll
  // forces overflow-x to "auto" and a spurious horizontal scrollbar appears.
  overflowX: "hidden"
};

const padding = {
  paddingTop: "7px",
  paddingRight: "5px",
  paddingBottom: "7px",
  paddingLeft: "10px"
};

const presetTimeframeCss = theme => ({
  padding: theme.themeId === "light" ? "7px 5px" : "5px",
  boxSizing: "border-box",
  cursor: "pointer",
  fontSize: "13px",
  "&:hover": {
    background: theme.palette.primary.main,
    color: theme.palette.text.inverted
  }
});

const customDateHeadingStyle = theme => ({
  fontSize: theme.themeId === "light" ? "0.7rem" : "0.6rem",
  textTransform: "uppercase",
  ...padding
});

const ThemedTimeframePicker = (props) => {
  const {theme} = React.useContext(CustomThemeContext);
  return <TimeframePicker theme={theme} {...props} />;
};

export default ThemedTimeframePicker;
